// extracted by mini-css-extract-plugin
export default {"lightGreen":"#0ff4a7","darkAbyss":"#313c54","darkerAbyss":"#21293a","white":"#fff","black":"#000","black10":"rgba(0,0,0,.1)"};